import { createAsyncThunk } from '@reduxjs/toolkit';

/**
 * Fire-and-forget notification when the user closes the cancellation
 * flow without submitting (Keep Subscription / X / ESC / overlay).
 * Failures are swallowed — abandon must never produce a UI error.
 */
const notifyCancellationAbandoned = createAsyncThunk(
  'billing/notifyCancellationAbandoned',
  async (
    payload,
    { extra: { sdk, Logger } },
  ) => {
    try {
      Logger.log('User', 'CancellationFlowKeepSubscription', {
        stage: payload?.stage,
        exitReason: payload?.exitReason,
      });

      await sdk.billing.notifyCancellationAbandon(payload);
      return { success: true };
    } catch (error) {
      Logger.error(
        new Error('Cancellation flow abandon notification failed'),
        { error },
        [
          'CancellationFlowAbandonFailed',
          {
            errorMessage: (error && error.message) || 'NoMessage',
            stage: payload && payload.stage ? String(payload.stage) : 'unknown',
            exitReason: (payload && payload.exitReason) || 'unknown',
          },
        ],
      );
      return { success: false };
    }
  },
);

export default notifyCancellationAbandoned;
